<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Cidadãos sem ACS"
            description="Cidadãos sem vinculação com qualquer ACS"
            url="/gestao-cadastros"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="info-table">
            <div class="info-table-item"></div>
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="Cidadãos-sem-AC"
              >
              </download-files>
            </div>
          </div>
          <v-app class="app-tabela">
            <div class="box" style="margin-top: 0px">
              <v-card class="tabela">
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Nome da equipe"
                    class="input-bottom"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  @pagination="getPagination"
                  :page="currentPage"
                  :footer-props="{
                    itemsPerPageText: '',
                    'items-per-page-options': [10],
                    'disable-items-per-page': true,
                  }"
                  :loading="loading"
                  loading-text="Carregando, Por favor espere"
                  :headers="headers"
                  :items="displayedCadastros"
                  :search="search"
                  item-key="id"
                  class="elevation-1"
                >
                  <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
                  <template v-slot:item.nu_cpf="{ item }">
                    <show-hide-field :value="item.nu_cpf"></show-hide-field>
                  </template>

                  <template v-slot:item.nu_cns="{ item }">
                    <show-hide-field :value="item.nu_cns"></show-hide-field>
                  </template>

                  <template v-slot:item.dt_nascimento="{ item }">
                    {{ formatDate(item.dt_nascimento) }}
                  </template>

                  <template v-slot:[`footer.page-text`]="items">
                    <div class="info-table-item tabela-esus-pec">
                      <p class="fonte">
                        <b>Fonte:</b> e-SUS PEC, {{ ultimaAtualizacao }}
                      </p>
                    </div>
                    <span class="paginacao"
                      >{{ items.pageStart }} - {{ items.pageStop }} de
                      {{ items.itemsLength }} pessoas</span
                    >
                  </template>
                  <template v-slot:progress>
                    <v-progress-linear
                      color="blue"
                      :height="10"
                      indeterminate
                    ></v-progress-linear>
                  </template>
                  <template v-slot:no-data>
                    <div class="alert alert-info mb-0">
                      <b
                        >Nenhuma informação encontrada. Selecione outro
                        filtro.</b
                      >
                    </div>
                  </template>
                  <template v-slot:no-results style="padding: 0px">
                    <div class="alert alert-info mb-0">
                      <b
                        >Nenhuma informação encontrada. Selecione outro
                        filtro.</b
                      >
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </v-app>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { mapState } from 'vuex'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'CidadaosSemAcs',
  metaInfo: {
    title: 'eSUS Feedback - Cidadãos sem ACS',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    ShowHideField,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cadastros: [],
      cadastrosOriginais: [],
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      search: '',
      headers: [
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          value: 'nu_cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          value: 'nu_cns',
        },
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
      ],
      currentPage: 1,
      filterSearchTable: false,
      dataFields: {
        Nome: 'no_cidadao',
        'Data de nascimento': {
          field: 'dt_nascimento',
          callback: (value) => {
            return value !== '' ? this.formatDate(value) : ''
          },
        },
        Mãe: 'no_mae',
      },
    }
  },
  watch: {
    search: {
      handler(newValue) {
        if (newValue) {
          this.filterSearch({ filter: this.filterItems(newValue) })
          return
        }
        this.filterSearch({ filter: false })
      },
      deep: true,
    },
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
    ...mapState(['user']),
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },
    getPagination(options) {
      this.currentPage = options.page
    },

    cidadaosSemAcs() {
      this.loading = true
      this.$api
        .get('/app/cidadaos-sem-acs/' + this.cod_ibge)
        .then((response) => {
          this.loading = false
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.total_de_registros_da_tabela = response.data.length
        })
        .catch(function (error) {
          console.log(error)
          this.loading = false
        })
    },

    generatePdf() {
      let title_pdf = 'Cidadãos sem ACS'
      let titlePdfSave = this.titlePdf('Cidadãos sem ACS')
      let description_pdf = 'Cidadãos sem vinculação com qualquer ACS'
      let headers_pdf = [
        'NOME',
        'DATA DE NASCIMENTO',
        'NOME DA MÃE',
        'DOCUMENTO',
      ]
      var data_pdf = []
      for (let i = 0; i < this.displayedCadastros.length; i++) {
        var obj = {}
        obj.no_cidadao = this.displayedCadastros[i].no_cidadao
        obj.dt_nascimento = this.formatDate(
          this.displayedCadastros[i].dt_nascimento
        )
        obj.no_mae = this.displayedCadastros[i].no_mae
        let documentoText = ''
    let lineBreak = ''
    if (this.displayedCadastros[i].nu_cpf !== null && this.displayedCadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${this.displayedCadastros[i].nu_cpf}`
    }
    if (this.displayedCadastros[i].nu_cns !== null && this.displayedCadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${this.displayedCadastros[i].nu_cns}`
    }
    obj.documento = documentoText
        data_pdf.push(obj)
      }
      let doc = new jsPDF(utils.methods.encryptionPdf())
      // cria a tabela
      let table = utils.methods.createTablePdf(data_pdf)

      utils.methods
        .fileToBase64(this.$store.state.infoMunicipio.brasao)
        .then((base64data) => {
          // Header
          let verticalPosition = utils.methods.headerPdf(
            doc,
            base64data,
            title_pdf,
            description_pdf
          )

          // Data atual
          let data = new Date()
          let dia = String(data.getDate()).padStart(2, '0')
          let mes = String(data.getMonth() + 1).padStart(2, '0')
          let ano = data.getFullYear()
          let dataAtual = dia + '/' + mes + '/' + ano
          doc.setFontSize(12)
          doc.text(`Data: ${dataAtual}`, 15, verticalPosition, null, null)

          verticalPosition += 6

          doc.autoTable({
            head: [headers_pdf],
            body: table,
            headStyles: {
              fillColor: '#ccc',
              fontSize: 6,
              textColor: '#000',
              halign: 'center',
              cellWidth: 'wrap',
            },
            bodyStyles: {
              halign: 'center',
              fontSize: 6,
            },
            theme: 'striped',
            startY: verticalPosition,
            showHead: 'firstPage',
            willDrawCell: function (data) {
              if (data.row.section === 'head') {
                doc.setTextColor(0, 0, 0)
              }
            },
          })

          utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

          doc.save(titlePdfSave + '.pdf')

          vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
            position: 'topRight',
          })
        })
        .catch((error) => {
          console.error(error)
          vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
            position: 'topRight',
          })
        })
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.cidadaosSemAcs()
    },
  },

  created() {
    this.init()
  },
}
</script>

<style></style>
